import React, {ReactElement, useEffect, useState} from 'react';
import NPCongrats from '../../../assets/images/np_congratulations.svg';
import RupeesIcon from '../../../assets/images/rupees.svg';
import {
  getAccessToken,
  getStoreInformation,
} from '../../../core/localstorage-data';
import {OrderResponse, ItemListType} from '../../../lib/order-types';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {
  addFreebie,
  notification,
  removeFreebie,
  setCartItemsCount,
} from '../../../redux/orderSlice';

type FreebiesProps = {
  orderResp: OrderResponse | null;
};
const Freebies: React.FC<FreebiesProps> = ({
  orderResp,
}: FreebiesProps): ReactElement => {
  const dispatch = useAppDispatch();
  const storeCode = `0${getStoreInformation().store_code}`;
  const accessToken = getAccessToken();
  const notificationState = useAppSelector(notification);
  const [freebieList, setFreebieList] = useState<any>(null);

  useEffect(() => {
    if (notificationState && notificationState.statusCode === '206') {
      if (orderResp && orderResp.itemList) {
        dispatch(setCartItemsCount(orderResp.itemList.length));
      }
    }
  }, [notificationState]);

  useEffect(() => {
    if (orderResp && orderResp.availableFreeBieList) {
      if (orderResp.selectedFreeBie) {
        const selectedFreebie = orderResp.selectedFreeBie;
        const index = orderResp.availableFreeBieList.findIndex(
          freebie => freebie.itemID === selectedFreebie?.itemID,
        );
        if (index !== -1) {
          const freebieListCopy = JSON.parse(
            JSON.stringify(orderResp.availableFreeBieList),
          );
          const updatedFreebieList = freebieListCopy.map(
            (list: ItemListType) => {
              if (list.itemID === selectedFreebie?.itemID) {
                list['isSelected'] = true;
              }
              return list;
            },
          );
          setFreebieList(updatedFreebieList);
        }
      } else {
        return setFreebieList(orderResp.availableFreeBieList);
      }
    }
  }, [orderResp]);

  const [total, setTotal] = useState(0);
  useEffect(() => {
    let totalMRP = 0;
    let promoDiscountAmount = 0;
    let bagPrice = 0;
    orderResp &&
      orderResp.itemList &&
      orderResp.itemList.forEach(item => {
        totalMRP += item.sellPrice;
        promoDiscountAmount += item.promoDiscountAmount;
      });
    if (orderResp && orderResp.carryBagItem) {
      bagPrice =
        orderResp.carryBagItem.sellPrice * orderResp.carryBagItem.quantity;
    }

    let couponTotalDiscount = 0;
    orderResp &&
      orderResp.itemList &&
      orderResp.itemList.forEach(item => {
        if (item.couponDiscountAmount) {
          couponTotalDiscount += item.couponDiscountAmount;
        }
      });
    // let freeBiePrice = 0;
    // if (orderResp && orderResp.selectedFreeBie) {
    //   freeBiePrice += orderResp.selectedFreeBie.extSellPrice;
    // }

    let totalAmount =
      orderResp && orderResp.itemList
        ? orderResp.itemList.reduce((prevAmount, item) => {
            return prevAmount + item.extSellPrice;
          }, 0)
        : 0;
    totalAmount = totalAmount + bagPrice;

    setTotal(Number(totalAmount));
  }, [orderResp]);

  function handleAddFreebie(freebie: ItemListType) {
    if (orderResp) {
      const parameters = {
        accessToken,
        payload: {
          storeCode,
          orderId: orderResp.orderId,
          selectedFreebieId: freebie.itemID,
        },
      };
      dispatch(addFreebie(parameters));
    }
  }
  function handleRemoveFreebie(freebie: ItemListType) {
    if (orderResp) {
      const parameters = {
        accessToken,
        payload: {
          storeCode,
          orderId: orderResp.orderId,
        },
      };
      dispatch(removeFreebie(parameters));
    }
  }
  return (
    <div className="pb-44 h-full overflow-y-auto">
      <div className="flex place-content-center py-4">
        <img src={NPCongrats} />
      </div>
      <div className="pb-2 font-roboto text-big">Congratulations!</div>
      <div className="pt-4 px-4 font-roboto text-xl leading-tight">
        <span>You are eligible for some freebies based on your cart value</span>
      </div>
      <div className="pt-2 font-roboto text-xxs text-center">
        *Please note you can select only one freebie
      </div>
      <div className="mt-8 px-4 ">
        {freebieList &&
          freebieList.map(
            (freebie: ItemListType, index: React.Key | null | undefined) => {
              return (
                <FreebiesCard
                  key={index}
                  freebie={freebie}
                  onAddFreebies={handleAddFreebie}
                  onRemoveFreebies={handleRemoveFreebie}
                />
              );
            },
          )}
      </div>
      <div className="bg-blue_zero flex justify-between font-roboto font-medium h-12 items-center px-4 w-full absolute bottom-0">
        <div className="text-white">Total</div>
        {total > 0 && <div className="text-white">{total.toFixed(2)}</div>}
      </div>
    </div>
  );
};
export default Freebies;

type FreebieCardProps = {
  onAddFreebies: (freebie: ItemListType) => void;
  onRemoveFreebies: (freebie: ItemListType) => void;
  freebie: ItemListType;
};
const FreebiesCard: React.FC<FreebieCardProps> = ({
  freebie,
  onAddFreebies,
  onRemoveFreebies,
}: FreebieCardProps): ReactElement => {
  console.log(freebie);
  function onAddToBag() {
    onAddFreebies(freebie);
    console.log('added');
  }

  function onRemove() {
    onRemoveFreebies(freebie);
  }

  return (
    <div className="px-4 py-4 mb-4 bg-blue_two rounded-2xl">
      <div className="flex justify-between font-roboto items-center">
        <div className="text-xxl text-left font-bold w-4/5">
          {freebie.itemDesc}
        </div>
        <div className="font-medium text-semibig w-1/5">
          {'\u20B9'} {freebie.extSellPrice}
        </div>
      </div>
      <div className="mt-2 mb-4 font-roboto">
        <div className="text-small text-left w-4/5">
          {freebie?.promoList[0].promoDesc}
        </div>
      </div>
      <div className="border-gray-300 border-solid border-0.2"></div>
      {freebie.isSelected ? (
        <div
          className="mt-2 text-center text-small font-bold text-red_zero"
          onClick={onRemove}>
          Remove
        </div>
      ) : (
        <div
          className="mt-2 text-center text-small font-bold text-red_zero"
          onClick={onAddToBag}>
          Add to bag
        </div>
      )}
    </div>
  );
};
